const de = {
  title: 'Alle Lawinenunfälle in der Schweiz seit 2004',
  sub: 'Gemeldete Unfälle von Oktober 2004 bis 7. Januar 2025',
  accidents: 'Unfälle',
  deaths: 'Todesfälle',
  tours: 'nur Tourengänger',
  variants: 'nur Variantenfahrer',
  data: 'Daten: ',
  slf: 'SLF',
  link: 'https://www.slf.ch/de/lawinen/unfaelle-und-lawinen/toedliche-lawinenunfaelle-20-jahre/',
  ctrl: 'ctrl-Taste + Scroll, um zu zoomen',
  command: '⌘-Taste + Scroll, um zu zoomen',
  touch: 'Benutzen Sie zwei Finger, um die Karte zu bewegen',
  meters: 'm ü. M.',
  caught: 'Erfasste Personen:',
  buried: 'Davon verschüttet:',
  killed: 'Davon getötet:',
  location: 'Erfassungsort:',
  unknown: 'unbestimmt',
  tourarea: 'Tourengelände',
  variantsarea: 'Variantengelände',
  toursorvariants: 'Tourengelände oder Variantengelände',
  trafficarea: 'Verkehrswege (z.B. Skipisten, Strassen)',
  variantsortraffic:
    'Variantengelände oder Verkehrswege (z.B. Skipisten, Strassen)',
  buildings: 'Gebäude',
  trafficorbuildings: 'Verkehrswege (z.B. Skipisten, Strassen) oder Gebäude',
  direction: 'Hangausrichtung:',
  notdefined: 'keine Angabe',
  north: 'Norden',
  northeast: 'Nordosten',
  east: 'Osten',
  southeast: 'Südosten',
  south: 'Süden',
  southwest: 'Südwesten',
  west: 'Westen',
  northwest: 'Nordwesten',
  danger: 'Herrschende Gefahrenstufe',
  nobulletin: 'Kein Bulletin vorhanden',
  stage1: 'Stufe 1: gering',
  stage2: 'Stufe 2: mässig',
  stage3: 'Stufe 3: erheblich',
  stage4: 'Stufe 4: gross',
  stage5: 'Stufe 5: sehr gross',
  notinzone: 'Unfallort nicht innerhalb der kritischsten Hang- und Höhenlage',
  increasezone: 'Anstieg der Lawinengefahr im Tagesverlauf auf Stufe',
  activateMap: 'Karte aktivieren',
  deactivateMap: 'Karte deaktivieren',
}
const fr = {
  title: 'Tous les accidents d’avalanche en Suisse depuis 2004',
  sub: 'Accidents signalés d’octobre 2004 au 7 janvier 2025',
  accidents: 'Accidents',
  deaths: 'Décès',
  tours: 'Uniquement randonneurs à ski',
  variants: 'Uniquement skieurs hors-piste',
  data: 'Données: ',
  slf: 'SLF',
  link: 'https://www.slf.ch/fr/avalanches/accidents-et-avalanches/accidents-davalanche-20-ans/',
  ctrl: 'Touche ctrl + scroll pour zoomer',
  command: 'Touche ⌘ + scroll pour zoomer',
  touch: 'Utilisez deux doigts pour déplacer la carte',
  meters: 'm',
  caught: 'Personnes emportées:',
  buried: 'Dont ensevelies:',
  killed: 'Dont décédées: ',
  location: 'Emplacement de saisie:',
  unknown: 'Inconnu',
  tourarea: 'Zone de randonnée',
  variantsarea: 'Zone de hors-piste',
  toursorvariants: 'Zone de randonnée ou de hors-piste',
  trafficarea: 'Voie de communication (p. ex. piste de ski, route)',
  variantsortraffic:
    'Zone de hors-piste ou voie de communication (p. ex. piste de ski, route)',
  buildings: 'Bâtiment',
  trafficorbuildings:
    'Voie de communication (p. ex. piste de ski, route) ou bâtiment',
  direction: 'Orientation de la pente:',
  notdefined: 'Pas de données',
  north: 'Nord',
  northeast: 'Nord-est',
  east: 'Est',
  southeast: 'Sud-est',
  south: 'Sud',
  southwest: 'Sud-ouest',
  west: 'Ouest',
  northwest: 'Nord-ouest',
  danger: 'Degré de danger en vigueur:',
  nobulletin: 'Pas de bulletin disponible',
  stage1: 'Degré 1: faible',
  stage2: 'Degré 2: limité',
  stage3: 'Degré 3: marqué',
  stage4: 'Degré 4: fort',
  stage5: 'Degré 5: très fort',
  notinzone:
    'Le lieu de l’accident ne se trouve pas sur la pente ou à l’altitude la plus critique',
  increasezone:
    'augmentation du risque d’avalanche au courant de la journée au',
  activateMap: 'Activer la carte',
  deactivateMap: 'Désactiver la carte',
}
export { de, fr }
